import { objectToSnakeCase, objectToCamelCase } from '../utils'

import api from './api'
// import Goal from '../goals'

export default class Photo {
  static api = api.create(Photo)

  constructor({
    id = null,
    photo = '',
    project = null,
    projectRef = null,
    goal = null,
    update = null,
  } = {}) {
    Object.assign(this, {
      id,
      photo,
      project,
      projectRef,
      goal,
      update,
    })
  }

  copy() {
    return new Photo(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Photo(data)
  }

  static fromAPI(json = {}) {
    return new Photo(objectToCamelCase(json))
  }

  /* Prep data for the API. Can elect to include */
  static toAPI(photo, fields = []) {
    let data = {}
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = photo[field]
      })
      photo.attributes = photo.attributesRef
    } else {
      data = photo
    }

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Photo)) {
      throw Error(`${name} must be an instance of the Photo class.`)
    }
  }
}
